import { columns, drawerFilters, toolbarActions } from './helpers'
import { useMemo, useState } from 'react'
import { toTableRowItems } from './serializers'
import { useNavigate } from 'react-router-dom'
import s from '../../../commonStyles.modules.scss'
import { useNotification } from 'hooks'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { formatErrorMessage } from 'utils/formatting'
import { Table } from 'components/core-ui/Table'
import {
  getDepositOptions,
  getHubOptions,
  getLocation,
  getShopOptions,
  getStatusOptions
} from '../../api'
import { formatAndDownloadResponse, formatUIDate } from 'utils/helpers'

const TruckList = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const navigate = useNavigate()

  const [tableItems, setTableItems] = useState<TruckItem[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)
  const [hasFilters, setHasFilters] = useState<boolean>(false)

  const { data: shopOptions } = getShopOptions(showNotification)
  const { data: hubOptions } = getHubOptions(showNotification)
  const { data: depositOptions } = getDepositOptions(showNotification)
  const { data: statusOptions } = getStatusOptions(showNotification)
  const { data: locationOptions } = getLocation(showNotification)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    const filters = tableFilters.map(filter =>
      filter.name === 'start'
        ? { name: filter.name, value: formatUIDate(filter.value) }
        : filter.name === 'end'
        ? { name: filter.name, value: formatUIDate(filter.value) }
        : filter
    )

    setHasFilters(filters.length > 0)

    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: isHistorical ? '/shop-reception/truckArchive' : '/shop-reception/truck',
          tableFilters: filters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)

    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const exportFileExcel = async (tableState, e) => {
    setIsExcelExportLoading(true)
    const { filters, order, orderBy } = tableState

    const tableFilters = filters.map(filter =>
      filter.name === 'start'
        ? { name: filter.name, value: formatUIDate(filter.value) }
        : filter.name === 'end'
        ? { name: filter.name, value: formatUIDate(filter.value) }
        : filter
    )
    const url = toTableGETUrl({
      url: isHistorical ? '/shop-reception/truckArchive/export' : '/shop-reception/truck/export',
      tableFilters,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response);
      setIsExcelExportLoading(false)
    } catch (error) {
      setIsExcelExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(() => toolbarActions({
      hasFilters, totalCount,
      exportFileExcel: exportFileExcel,
      isExcelExportLoading }),
    [hasFilters, totalCount, exportFileExcel, isExcelExportLoading])

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns(navigate, isHistorical)}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        toolbarActions={toolbar}
        filters={drawerFilters(
          shopOptions,
          hubOptions,
          depositOptions,
          statusOptions,
          locationOptions
        )}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default TruckList
